import { registerPlugin } from '@capacitor/core';
const KeyManager = registerPlugin('KeyManager', {
    web: () => import('./web').then((m) => new m.KeyManagerWeb()),
});
export * from './definitions';
export { KeyManager };
//# sourceMappingURL=index.js.map